import { render, staticRenderFns } from "./AccionesCorrectivasPagination.vue?vue&type=template&id=50070906&"
import script from "./AccionesCorrectivasPagination.vue?vue&type=script&lang=js&"
export * from "./AccionesCorrectivasPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports